/**
 * Smooth scroll polyfill for IE and Edge
 * Needed for any .scrollTo(), .scrollTop(), etc... calls
 */
//@ts-ignore
import smoothscroll from 'smoothscroll-polyfill'
// kick off the polyfill!
smoothscroll.polyfill()
